<template>
  <form @submit.prevent="submit">
    <div class="modal-card reject-order-modal">
      <header class="modal-card-head">
        <div class="modal-card-title">
          <p class="has-text-weight-bold title">Reject Order</p>
        </div>
      </header>
      <section class="modal-card-body">
        <b-field label="Reason of Rejection">
          <b-input name="reason" v-model="message" type="textarea"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button id="reject_order" :class="`button is-info ${loading ? 'is-loading' : ''}`">
          Reject
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  orderService: OrderService,
  props: {
    order: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    message: "",
    loading: false
  }),
  methods: {
    async submit() {
      this.loading = true;
      try {
        const order = await this.$options.orderService
          .rejectBilling(this.order.id, {reject_reason: this.message, includes: "state,attributes" })
          .then(response => JsonDenormalizer.denormalize(response.data));

        this.order.status = order.status;
        this.order.attributes = order.attributes;

        // Set order state
        this.$store.commit("OrderState/SET_STATE", order.state);

        this.$buefy.toast.open({
          message: "Order has been rejected.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$parent.close();

      } catch (err) {}

      this.loading = false;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Orders/list-new/partials/RejectOrderModal.vue